var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Stories',{directives:[{name:"show",rawName:"v-show",value:(_vm.shown),expression:"shown"}],attrs:{"stories":_vm.items,"duration":_vm.duration},on:{"stories-end":_vm.storiesEnd}})
}
var staticRenderFns = []

export { render, staticRenderFns }